import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { filter } from "rxjs";
import { LaunchDarklyService } from "src/app/core/layout/launch-darkly/launch-darkly.service"

export const launchDarklyResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(LaunchDarklyService).isReady$.asObservable().pipe(
    filter(res => res),
  );
}
